import React, { useMemo } from 'react'

import ImagePreview from 'common/builder/components/chart/FlowChart/nodes/blocks/common/ImagePreview'

import * as styles from './PreviewComponent.style'

interface PreviewComponentProps {
  url: string
  size: {
    width: number
    height: number
  } | null
  targetWidth: number
  ratio?: number
  style?: React.CSSProperties
  connectedToNext?: boolean
  connectedToPrevious?: boolean
}

export const PreviewComponent = ({
  url,
  size,
  targetWidth,
  ratio,
  style: externalStyle = {},
  connectedToNext,
  connectedToPrevious,
}: PreviewComponentProps) => {
  const mergedStyle = useMemo(
    () => ({
      ...styles.Image,
      ...externalStyle,
      ...(connectedToNext ? styles.ConnectedToNext : {}),
      ...(connectedToPrevious ? styles.ConnectedToPrevious : {}),
    }),
    [connectedToNext, connectedToPrevious, externalStyle],
  )

  return (
    <ImagePreview
      url={url}
      ratio={ratio}
      style={mergedStyle}
      originalSize={size}
      targetWidth={targetWidth}
    />
  )
}
